import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  FormControlLabel,
  Checkbox
} from '@mui/material';

export default function DeletedRouteConfirmedDialog({ open, loading, onClose, onConfirm, routeName }) {
  const [inputValue, setInputValue] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    if (open) {
      setInputValue('');
      setIsAgreed(false);
    }
  }, [open]);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleConfirm = () => {
    if (inputValue === routeName && isAgreed) {
      if (onConfirm) onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Delete Route</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body1" gutterBottom color="error">
            WARNING: Deleting this route will also delete all associated historical trips!
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            If you are absolutely sure you want to delete this route, please type the route name <strong>{routeName}</strong> correctly
            below:
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={routeName || 'Route Name'}
            sx={{ mb: 2 }}
          />
          <FormControlLabel
            control={<Checkbox checked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)} color="error" />}
            label={<Typography variant="body2">Please check this box if you understand the rules regarding data deletion.</Typography>}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={loading || inputValue !== routeName || !isAgreed} color="error" variant="contained">
          {loading ? 'Deleting...' : 'Confirm Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
